import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-send-email',
  templateUrl: './add-send-email.component.html',
  styleUrls: ['./add-send-email.component.css']
})
export class AddSendEmailComponent implements OnInit {
  labelResponse=''
  responsedatadbemailConfig=[];
FormaddSend:FormGroup;
  constructor(private http:HttpClient,
    private formbuilder:FormBuilder,
    private auten:AuthenticationService,
    public dialogRef: MatDialogRef<AddSendEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

    this.responsedatadbemailConfig=[];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.FormaddSend=this.formbuilder.group({
email:[""],
sendto:[""],
active:[true]


    })
    this.FormaddSend.controls.email.setValue(this.data.Email);
    this.onChangedatadbEmailConfing(this.data.Email)
  }
  onChangeItemTableNew () {


    var js={
      "companyId": Number(this.auten.currentUserValue.companyIdWh),
      "emailCustomer": String(this.FormaddSend.controls.email.value),
      "emailSend": String(this.FormaddSend.controls.sendto.value),
      "active": Number(this.FormaddSend.controls.active.value)
    }
    this.http
      .post<any>(
        `${
          environment.apiUrl
        }/Administracion/addSendCopyCustomerToemail`,js,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
       try {
        this.labelResponse=String(response.responses)
       } catch (error) {
        
       }
      })
  }
onChangedatadbEmailConfing(email:any){

  this.http
  .get<any>(
    `${
      environment.apiUrl
    }/Administracion/addSendCopyCustomerToemailGet?email=${String(email)}&companyID=${Number(this.auten.currentUserValue.companyIdWh)}`,

    {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization:
          'Bearer ' + this.auten.currentUserValue.token
      })
    }
  )
  .subscribe((response: any) => {
   this.responsedatadbemailConfig=response;
   try {
   
    if (this.responsedatadbemailConfig.length>0) {
   
      for (let index = 0; index < this.responsedatadbemailConfig.length; index++) {
        const element = this.responsedatadbemailConfig[index];
        this.FormaddSend.controls.sendto.setValue(element.emailsend)
        this.FormaddSend.controls.active.setValue(Boolean(element.active))
  
      }
     
    }
   } catch (error) {
    
   }
  })


}


}
